@if (!isPartner) {
  <div [formGroup]="form" class="row" data-cy="vehicleAssignmentForm">
    <div class="column twelve md-eight">
      <ds-form-control-container [labelText]="driver" [control]="selectionCtrl">
        <select
          id="vehicleAssignmentSelect"
          class="icon fill"
          data-cy="vehicleAssignmentFormSelect"
          [formControlName]="driver"
          (change)="vehicleAssignmentChange()"
        >
          <option value="unset" selected disabled>Choose Vehicle</option>
          @for (vehicle of vehicles; track vehicle) {
            <option [value]="vehicle.vin">
              {{ vehicle.description }}
            </option>
          }
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </div>
  </div>
}

@if (isPartner) {
  <div [formGroup]="form" class="row" data-cy="vehicleAssignmentForm">
    <div class="column twelve md-eight">
      <ds-form-control-container [labelText]="newDriver.displayName" [control]="selectionCtrl">
        <select
          id="vehicleAssignmentSelect"
          class="icon fill"
          data-cy="vehicleAssignmentFormSelect"
          [formControlName]="newDriver.fixedId.toString()"
          (change)="
            emitUpdateDriverAssignments({
              vehicle: $event.target.value,
              driver: newDriver,
              selectedId,
              driverAssignments
            })
          "
        >
          <option value="unset" selected disabled>Choose Vehicle</option>
          @for (vehicle of combinedVehicles(); track vehicle) {
            <option [value]="vehicle.description">
              {{ vehicle.description }}
            </option>
          }
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </div>
  </div>
}
